import App from './components/App';
import { HashRouter } from 'react-router-dom';

wp.element.render( <HashRouter><App /></HashRouter>, document.getElementById('simpleform-app-root') );